import React, { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import PageLoader from '../../@jumbo/components/PageComponents/PageLoader';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AuhMethods } from '../../services/auth';
import { CurrentAuthMethod } from '../../@jumbo/constants/AppConstants';

const ExtraPages = ({ match }) => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Route component={lazy(() => import('../Pages/404'))} />
      </Switch>
    </Suspense>
  );
};

function doRedirect(url, token2) {
  const token = localStorage.getItem('token');
  const senddata = {
    Action: 'Redirect',
    token: token,
    URL: url,
  };

  var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
  axios
    .post(pmsUrl, senddata, {
      withCredentials: true,
    })
    .then(res => {
      window.location = url;
    });
}

const MyGastro = ({ match }) => {
  const requestedUrl = match.url.replace(/\/$/, '');
  const { authUser } = useSelector(({ auth }) => auth);
  const dispatch = useDispatch();
  const history = useHistory();
  //  const query = new URLSearchParams(this.props.location.search);

  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Route path={`${requestedUrl}/homepage`} component={lazy(() => import('./gastroHomePage'))} />
        <Route path={`${requestedUrl}/revenue`} component={lazy(() => import('./gastroRevenue'))} />
        <Route path={`${requestedUrl}/reset`} component={lazy(() => import('./gastroReset'))} />
        <Route path={`${requestedUrl}/tables/:posId/:myDate`} component={lazy(() => import('./gastroTables'))} />
        <Route path={`${requestedUrl}/tables`} component={lazy(() => import('./gastroTables'))} />
        <Route path={`${requestedUrl}/invoices`} component={lazy(() => import('./gastroInvoices'))} />
        <Route path={`${requestedUrl}/orders`} component={lazy(() => import('./gastroOrders'))} />
        <Route path={`${requestedUrl}/log`} component={lazy(() => import('./gastroLog'))} />
        <Route path={`${requestedUrl}/analytics`} component={lazy(() => import('./gastroAnalytics'))} />
        <Route path={`${requestedUrl}/wh`} component={lazy(() => import('./gastroWH'))} />
        <Route
          path={`${requestedUrl}/logout`}
          component={lazy(() => {
            const myMode = 1;
            dispatch(AuhMethods[CurrentAuthMethod].onLogout2({ myMode }));
            //history.push('/mobile');
            //window.location = '/mobile';
            return null;
          })}
        />
        <Route component={lazy(() => import('../Pages/404'))} />
      </Switch>
    </Suspense>
  );
};

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default MyGastro;

//export default ExtraPages;
